/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/revenue/lifetime_stats" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroupIdChartsRevenueLifetimeStats } from "./constants";
import type { AppGroupRevenueLifetimeStatsResults } from "./types";

export const getAppGroupRevenueLifetimeStats = reactQueryFetcherAdapter(
  appsAppGroupIdChartsRevenueLifetimeStats,
  (signal: AbortSignal, appGroupId: string): Promise<AppGroupRevenueLifetimeStatsResults> => {
    return fetch(`/apps/${appGroupId}/charts/revenue/lifetime_stats`, "GET", {}, { signal });
  }
);
